__webpack_require__.p = "/assets/turbo/321607da/quellede/_next/";